import { Block, Box, transitionsDelay } from '../../../styles/basicStyles';
import styled, { css } from 'styled-components';

export const ArticleWrapper = styled(Box)`
  cursor: pointer;
  width: unset;
  align-items: center;

  & span {
    transition: color ${transitionsDelay} linear, font-weight ${transitionsDelay} linear;
  }

  &:hover {
    & span {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.chineseBlack};
    }
  }
`;

export const SelectedFilter = styled(Block)`
  width: 0.938rem;
  height: 0.188rem;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  margin-right: 0.375rem;
`;

export const Line1 = styled.div<{ started: boolean }>`
  position: absolute;
  left: 0;
  top: 35rem;
  z-index: 1;
  width: 100%;

  & svg {
    width: 100%;
    height: auto;
  }

  ${({ started }) => started ?
    css`
      display: block; 

      & path {
        stroke-dasharray: 10000;
        stroke-dashoffset: 10000;
        animation-duration: 15s;
        animation-name: dash;
        animation-iteration-count: 1;
        animation-delay: 0s;
        animation-fill-mode: forwards;
      }

      @keyframes dash {
        to {
          stroke-dashoffset: 0;
        }
      }
    `
    :
    css`
      display: none;
    `
  }
`;

export const CarouselWrapper = styled(Block)`
  & .mantine-Carousel-slide {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
`;

export const BlogWrapper = styled(Block)`
  flex-flow: row wrap;
`;

export const BlogPostWrapper = styled(Block)`
  & .react-reveal {
    width: 100%;
    height: 100%;
  }
`;
